<template>
  <scout-topic-panel
    title="スカウト済み"
    name="scout"
    tooltip="掲載期間＋１週間、無料で再スカウトを送信することができます。"
  >
    <router-link
      :to="{ name: 'scoutScouted', params: { contractId: contractId + '' , jobId: jobId + ''} }"
      class="pega-text-link"
    >
      <span
        data-test="link-text"
        class="boss-scoutandlike-text"
      >{{ count }}名<br>
        <small
          v-if="scoutEndDate"
          data-test="scout-end-date"
        >再送期限：{{ scoutEndDate | formatDate }}まで</small>
      </span>
    </router-link>
  </scout-topic-panel>
</template>

<script>
import ScoutTopicPanel from '@/components/atoms/ScoutTopicPanel'
import { createDate } from '@/lib/dateUtils.js'

export default {
  components: { ScoutTopicPanel },
  filters: {
    formatDate (val) {
      return createDate(val)?.format('YYYY/MM/DD') ?? ''
    }
  },
  props: {
    contractId: {
      type: Number,
      required: true
    },
    jobId: {
      type: Number,
      required: true
    },
    scoutEndDate: {
      type: String,
      default: null
    },
    count: {
      type: Number,
      default: 0
    }
  }
}

</script>
